import * as actionTypes from "./actionTypes";
import axios from '../../axios-orders';

export const addIngredient = (name) => {
    return{
        type:actionTypes.ADD_INGREDIENT,
        ingredientName:name
    }
};

export const removeIngredient = (name) => {
    return{
        type:actionTypes.REMOVE_INGREDIENT,
        ingredientName:name
    }
};

export const setIngredients = (ingredients) => {
    return {
        type: actionTypes.SET_INGREDIENTS,
        ingredients:ingredients
    }
}

export const fetchIngredientsFalied = () => {
        return{
            type: actionTypes.FETCH_INGREDIENTS_FAILED
        }
}

export const initIngrerdients = () => {
    return dispatch=>{
        axios.get('https://react-my-burger-a4c31.firebaseio.com/ingredients.json')
            .then(res=>{
                dispatch(setIngredients(res.data));
            })
            .catch(error=>{
                // console.log(error);
                // this.setState({error:true})
                dispatch(fetchIngredientsFalied());
            });
    }
}